import { render, staticRenderFns } from "./Inspection.vue?vue&type=template&id=484530d6&scoped=true&"
import script from "./Inspection.vue?vue&type=script&lang=js&"
export * from "./Inspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484530d6",
  null
  
)

export default component.exports